import { render, staticRenderFns } from "./sell-modal.vue?vue&type=template&id=45cef751&scoped=true&"
import script from "./sell-modal.vue?vue&type=script&lang=js&"
export * from "./sell-modal.vue?vue&type=script&lang=js&"
import style0 from "./sell-modal.vue?vue&type=style&index=0&id=45cef751&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45cef751",
  null
  
)

export default component.exports